import $ from 'jquery'
import Swiper from 'swiper';
import { Navigation} from 'swiper/modules';
Swiper.use([Navigation]);

export default () => {
    let shopifyCart;

    const sliderNodeSelectors = {
        containerHolder: '[js-cart-slider="container-holder"]',
        container: '[js-cart-slider="container"]',
        prevArrow: '[js-cart-slider="prev"]',
        nextArrow: '[js-cart-slider="next"]',
    }

    const nodeSelectors = {
        openNotice: '[js-notice="open"]',
        closeNotice: '[js-notice="close"]',
        noticeContentBody: '[js-notice="content-body"]',
        notice: '[js-notice="wrapper"]',
        noticeContent: '[js-notice="content"]',

        cartTotalItems: '[js-cart="total-items"]',
        cartTotalItemsHeader: '[js-cart="total-items-header"]',
        open: '[js-cart="open"]',
        cart: '[js-cart="wrapper"]',
        cartLoader: '[js-cart="loader"]',
        addCartItem: '[js-cart="add-cart-item"]',
        cartContentBody: '[js-cart="content-body"]',
        cartContent: '[js-cart="content"]',
        close: '[js-cart="close"]',
        cartFooter: '[js-cart="footer"]',
        cartItems: '[js-cart="cart-items"]',
        cartPrice: '[js-cart="cart-price"]',
        cartItemQuantityMinusBtn: '[js-cart="item-quantity-minus"]',
        cartItemQuantityPlusBtn: '[js-cart="item-quantity-plus"]',
        cartItemQuantityInput: '[js-cart="item-quantity-input"]',
        cartItemRemove: '[js-cart="remove-item"]',
        cartEmpty: '[js-cart="empty"]',
        cartSliderContainer: '[js-cart="slider-container"]',
        cartGift: '[js-cart="gift"]',
        cartSecureCheckoutOpener: '[js-cart="secure-checkout"]',
    }

    function init() {
        if (!$(nodeSelectors.cart).length) {
            return
        }

        initCart()
    }

    async function initSlider() {
        
        let res = await fetch('/?sections=cart-slider')
        let resJson = await res.json()
        $(nodeSelectors.cartSliderContainer).html(resJson['cart-slider'])

        let slider = new Swiper(sliderNodeSelectors.container, {
            slidesPerView: 1.25,
            spaceBetween: 25,
            speed: 500,
            threshold: 50,
            allowTouchMove: true,
            cssMode: true,
            centeredSlides: true,
            centeredSlidesBounds: true,
            navigation: {
                prevEl: sliderNodeSelectors.prevArrow,
                nextEl: sliderNodeSelectors.nextArrow,
            },
            breakpoints: {
                600: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 2,
                    cssMode: false,
                    centeredSlides: false,
                    centeredSlidesBounds: false,
                }
            }
        });

        // if($(nodeSelectors.cartSliderContainer).find('.swiper-wrapper .swiper-slide').length){
        //     $(sliderNodeSelectors.containerHolder).fadeIn()
        // } else{
        //     $(sliderNodeSelectors.containerHolder).fadeOut()
        // }
    }

    // function removeSlider() {
    //     // slider.destroy(true, false)
    //     $(sliderNodeSelectors.containerHolder).fadeOut()
    // }

    function initCart() {
        cartEvents()
        setCartContent()


        // ---------------------------------------------------------------------------
        // Money format handler
        // ---------------------------------------------------------------------------
        
        Shopify.money_format = "${{amount}}";
        Shopify.formatMoney = function(cents, format) {
        if (typeof cents == 'string') { cents = cents.replace('.',''); }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || this.money_format);
        
        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }
        
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');
        
            if (isNaN(number) || number == null) { return 0; }
        
            number = (number/100.0).toFixed(precision);
        
            var parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';
        
            return dollars + cents;
        }
        
        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
            case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
            case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
            case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
        
        return formatString.replace(placeholderRegex, value);
        };
        // ---------------------------------------------------------------------------
        // Money format handler end
        // ---------------------------------------------------------------------------

        // Progerss Bar Update
        $.ajax({
            type: "GET",
            url: "/cart.js",
            async: false,
            dataType: "json",
            cache: false,
            success: function (data) {
                var results = "";
                var price = data.total_price;
                if($(nodeSelectors.cartGift).length){
                    checkFreeShipping(price);
                }
                checkIfDealer(data);
            }
        });

        // $(nodeSelectors.cartSecureCheckoutOpener).on('click', function(){
        //     $('.secure-checkout-popup-wrap').fadeIn('fast').css('display', 'flex');
        // })

        // $('.secure-checkout-popup-overllay, .close-secure-checkout-wrap').on('click', function(){
        //     $('.secure-checkout-popup-wrap').fadeOut('fast')
        // })

        $('.qnt-wrap .minus').on('click', function () {
            var $input = $(this).parent().find('input');
            $input[0].stepDown();
            $input.change();
            $('.add-to-cart-button').data('quantity', $input.val())
        });
        
        $('.qnt-wrap .plus').on('click', function () {
            var $input = $(this).parent().find('input');
            $input[0].stepUp();
            $input.change();

            $('.add-to-cart-button').data('quantity', $input.val())
        });
    }

    // async function checkIfDealer(data){
    //     if($('body').hasClass('dealer-customer')){
    //         if(data.original_total_price < 1000000){
    //             await fetch('/discount/MOD Dealer').then(() => {
    //                 if($('#cart-item-43986492719244').length){
    //                     updateCartItem(43986492719244, 0)
    //                 }
    //             }).then(() => {
    //                 if($('body').hasClass('cart')){
    //                     setCartPageContent()
    //                 }
    //             });
    //         } else{
    //             await fetch('/discount/MOD Dealer Plus').then(() => {
    //                 if(!$('#cart-item-43986492719244').length){
    //                     $.ajax({
    //                         type: 'POST',
    //                         url: `${Shopify.routes.root}cart/add.js`,
    //                         dataType: 'json',
    //                         data: {
    //                             id: parseInt(43986492719244), // 44348997992736
    //                             quantity: parseInt(1)
    //                         },
    //                         success: function(data) {
    //                             setCartContent()
    //                         },
    //                         error: function (error) {
    //                             console.log(error)
    //                         }
    //                     });
    //                 }
    //             }).then(() => {
    //                 if($('body').hasClass('cart')){
    //                     setCartPageContent()
    //                 }
    //             });
    //         }
    //     }
    // }

    async function checkIfDealer(data){
        if($('body').hasClass('dealer-customer')){
            await fetch('/discount/MOD Dealer').then(() => {
                if($('body').hasClass('cart')){
                    setCartPageContent()
                }
            });

            // if(data.original_total_price < 1000000){
            //     await fetch('/discount/MOD Dealer').then(() => {
            //         if($('body').hasClass('cart')){
            //             setCartPageContent()
            //         }
            //     });
            // } else{
            //     await fetch('/discount/MOD Dealer Plus').then(() => {
            //         if($('body').hasClass('cart')){
            //             setCartPageContent()
            //         }
            //     });
            // }
        }
    }

    function checkFreeShipping(price) {
        var priceGoal = parseInt($(".gift-progress-bar").data('value')) ;
        priceGoal = priceGoal * Shopify.currency.rate
        var currentPercent;
        var leftToFreeShipping;
        
        currentPercent = (price / priceGoal) * 100;

        leftToFreeShipping = (priceGoal - price)/100;

        $(".gift-progress-bar span").css("width", currentPercent + "%");
        $(".gift-description .left-to-free").text(Shopify.formatMoney(leftToFreeShipping * 100, window.theme.moneyFormat).replace(/<\/?span[^>]*>/g,""));

        if (priceGoal <= price) {
          $(".gift-description").css('display', 'none');
          $(".gift-description-success").css('display', 'block');
        } else {
            $(".gift-description").css('display', 'flex');
            $(".gift-description-success").css('display', 'none');
        }
    }

    function cartEvents() {
        $(nodeSelectors.close).on('click', closeCart)
        $(nodeSelectors.open).on('click', openCart)

        $(nodeSelectors.closeNotice).on('click', closeNotice)
        $(nodeSelectors.openNotice).on('click', openNotice)

        // Update item quantity
        $(document).on('change', nodeSelectors.cartItemQuantityInput, function(){
            let id = $(this).data('variant-id')
            let quantity = $(this).find(":selected").val()
            updateCartItem(id, quantity)
        })

        // Remove/Update item quantity
        $(document).on('click', nodeSelectors.cartItemRemove, function(){
            updateCartItem($(this).data('variant-id'), 0)
        })

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
              let c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
        }

        $('.block-product-discount-checkbox-wrap').on('click', function(){
            // $(this).find('.container').trigger('click');
            var checkbox = $(this).find('input[type="checkbox"]');
            checkbox.prop('checked', !checkbox.prop('checked'));
            $(checkbox).trigger("change");
        })

        if($('.block-product-discount-checkbox').length){
            var arr = [];
            // var currentGift = $(".discount-checkbox-input").parent().data('gift')
            
            $('.block-product-discount-checkbox .container .product-discount-checkbox-input').each(function(){
                if(this.checked) {
                    var currentProductQuantity = $(this).parent().data('quantity')

                    if($(this).parent().data('variant')){
                        var currentProductId = $(this).parent().data('variant')
                    } else{
                        var currentProductId = $(this).parent().data('gift')
                    }

                    arr.push({
                        id: currentProductId,
                        quantity: currentProductQuantity
                    });
                }
            });

            $(".product-discount-checkbox-input").change(function() {
                arr = [];
                $('.block-product-discount-checkbox .container .product-discount-checkbox-input').each(function(){
                    
                    if(this.checked) {
                        var currentProductQuantity = $(this).parent().data('quantity')
                        
                        if($(this).parent().data('variant')){
                            var currentProductId = $(this).parent().data('variant')
                        } else{
                            var currentProductId = $(this).parent().data('gift')
                        }

                        arr.push({
                            id: currentProductId,
                            quantity: currentProductQuantity
                        });
                    }
                });

            })
        }
        
        if($('.block-discount-checkbox').length){
            var currentCookie = $(".discount-checkbox-input").parent().data('dcode');

            $( window ).on( "load", function() {
                if($('.block-discount-checkbox').data('applied') == true){
                    $(".block-discount-checkbox .container").trigger("click");
                }
            });

            if(currentCookie){
                if(!getCookie('discount_code').includes(currentCookie)){
                    $('.block-discount-checkbox .container').css('display', 'flex')
                } else{
                    $('.block-discount-checkbox .discount-applied').css('display', 'flex')
                }
            }

            $(".discount-checkbox-input").change(function() {
                if(this.checked) {
                    if(currentCookie){
                        fetch('/discount/'+ currentCookie).then(async (data) => {
                            
                            $('.block-discount-checkbox .container').css('display', 'none')
                            $('.block-discount-checkbox .discount-applied').css('display', 'flex')

                            if(!$('.block-discount-checkbox').data('applied') == true){
                                openCart()
                                $('.block-buy-buttons button').trigger('click')
                            }
                        });
                    }
                }
            });
        }

        // Add to cart with node selector
        // El must have data-id and data-quantity
        // $(document).on('click', nodeSelectors.addCartItem, function(e){
        //     if(!$('body').hasClass('cart')){
        //         e.preventDefault();
                
        //         // addCartItem($(this).parent().parent().find('input[name="id"]').val(), $(this).data('quantity'), arr)
        //         addCartItemFromForm($('form[action*="/cart/add"]'));
        //     }
        // })

        $(document).on('click', nodeSelectors.addCartItem, function(e){
            if (!$('body').hasClass('cart')) {
                e.preventDefault();

                const $form = $('form[action*="/cart/add"]');
                const $angiCheckbox = $('#angi-upsell-checkbox');

                let angiService = null;

                if ($angiCheckbox.length && $angiCheckbox.is(':checked') && $('.quick-buy-drawer > *').length == 0) {
                    angiService = {
                        variantId: $angiCheckbox.data('upsell-variant-id'),
                        quantity: 1,
                        productTitle: $angiCheckbox.data('main-product-title')
                    };
                }

                addCartItemFromForm($form, true, angiService);
            }
        });

        // reduce item quantity by 1
        $(document).on('click', nodeSelectors.cartItemQuantityMinusBtn, function(){
            let id = $(this).next().data('variant-id')
            let quantity = parseInt($(this).next().val()) - 1

            if( quantity > 0 ) {
                updateCartItem(id, quantity)
            }
        })
        

        // Increase item quantity by 1
        $(document).on('click', nodeSelectors.cartItemQuantityPlusBtn, function(){
            let id = $(this).prev().data('variant-id')
            let quantity = parseInt($(this).prev().val()) + 1
            updateCartItem(id, quantity)
        })
    }

    async function setCartPageContent() {
        let shopifyCartRes = await fetch(`${Shopify.routes.root}cart.js`)
        shopifyCart = await shopifyCartRes.json()

        if(shopifyCart.item_count > 0) {
            // Hide cart is empty and remove it
            let cartItemsRes = await fetch(`${Shopify.routes.root}?sections=cart-page-items`)
            let cartItemsJson = await cartItemsRes.json()
            $('.cart-items-list-holder').html(cartItemsJson['cart-page-items'])

            let cartItemsSubtotal = await fetch(`${Shopify.routes.root}?sections=cart-page-subtotal`)
            let cartItemsSubtotalJson = await cartItemsSubtotal.json()
            $('.Cart__Total').html(cartItemsSubtotalJson['cart-page-subtotal'])
        }
    }

    async function setCartContent() {
        // Show cart spinner/loader icon
        $(nodeSelectors.cartLoader).fadeIn(150)
        // Await for cart init
        let shopifyCartRes = await fetch(`${Shopify.routes.root}cart.js`)
        shopifyCart = await shopifyCartRes.json()

        // Set total cart items in header
        let cartTotalItemsText = ( shopifyCart.item_count !== 1 ) ? shopifyCart.item_count : shopifyCart.item_count
        $(nodeSelectors.cartTotalItems).text(' ('+cartTotalItemsText+')')
        // $(nodeSelectors.cartTotalItemsHeader).text(cartTotalItemsText)
        

        if(shopifyCart.item_count > 0){
            $('.total-items-header, .cart-count').text(shopifyCart.item_count).css('display', 'flex');
        } else{
            $('.total-items-header, .cart-count').text(shopifyCart.item_count).css('display', 'none');
        }

        // Set total cart price in footer
        setTotalPrice()

        // Set cart content
        if(shopifyCart.item_count > 0) {
            // Hide cart is empty and remove it
            $(nodeSelectors.cartEmpty).fadeOut()

            let cartItemsRes = await fetch(`${Shopify.routes.root}?sections=cart-items`)
            let cartItemsJson = await cartItemsRes.json()
            $(nodeSelectors.cartItems).html(cartItemsJson['cart-items'])

            // Show gift
            $('.cart_gift').fadeIn();

            // Show slider
            initSlider()

            // Show footer
            $(nodeSelectors.cartFooter).css('opacity', 1)
        } else {
            // Add Cart is empty
            $(nodeSelectors.cartEmpty).fadeIn()

            //Hide Gift
            $('.cart_gift').fadeOut();

            // Hide slider
            // removeSlider()

            // Hide footer
            $(nodeSelectors.cartFooter).css('opacity', 0)
        }

        // Hide cart spinner/loader icon
        $(nodeSelectors.cartLoader).fadeOut(150)

        // Progerss Bar Update
        $.ajax({
            type: "GET",
            url: '/cart.js',
            async: false,
            dataType: "json",
            cache: false,
            success: function (data) {
              var results = "";
              var price = data.total_price;
              if($(nodeSelectors.cartGift).length){
                checkFreeShipping(price);
              }
            },
        });
    }

    function updateCartItem(id, quantity) {
        // Show cart spinner/loader icon
        $(nodeSelectors.cartLoader).fadeIn(150)

        return $.ajax({
            type: 'POST',
            url: `${Shopify.routes.root}cart/change.js`,
            dataType: 'json',
            data: {
                id: parseInt(id),
                quantity: parseInt(quantity),
            },
            
            success: function(data) {
                if(quantity === 0) {
                    $('body').addClass('no-scroll')
                    // Remove item
                    $('#cart-item-' + id).slideUp(220, () => setCartContent() )
                } else {
                    $('body').addClass('no-scroll')
                    // Update item
                    setCartContent()
                }
                checkIfDealer(data);
            },
            error: function (e) {
                setCartContent().then(() => {
                    shopifyCart.items.map((item) => {
                        if(item.id === id && item.quantity < quantity) {
                            $('#cart-item-quantity-' + id).parent().after('<small class="error">Only '+item.quantity+' items available.</small>')
                        }
                    })
                })
            }
        });
    }

    // addCartItem(44746522984744, 1)
    
    function addCartItem(id, quantity = 1, arr, openCartAfter = true) {
        return $.ajax({
            type: 'POST',
            url: `${Shopify.routes.root}cart/add.js`,
            dataType: 'json',
            data: {
                id: parseInt(id), // 44348997992736
                quantity: parseInt(quantity)
            },
            success: function(data) {
                setCartContent().then((openCartAfter) ? openCart : null)

                if($('.block-product-discount-checkbox').length){
                    if(arr.length != 0 && $('.quick-buy-drawer > *').length == 0){
                        addCartMultipleItems(arr)
                    }
                }

                checkIfDealer(data);
            },
            error: function (error) {
                openCart()

                // Try to update item and to show the error for limit
                setCartContent().then(() => {
                    shopifyCart.items.map((item) => {
                        if(item.id === id && item.quantity < quantity) {
                            $('#cart-item-quantity-' + id).parent().after('<small class="error">Only '+item.quantity+' items available.</small>')
                        }
                    })
                })
            }
        });
    }

    // function addCartItemFromForm($form, openCartAfter = true) {
    //     const formData = $form.serialize();

    //     return $.ajax({
    //         type: 'POST',
    //         url: `${Shopify.routes.root}cart/add.js`,
    //         dataType: 'json',
    //         data: formData,
    //         success: function(data) {
    //             setCartContent().then(() => {
    //                 if (openCartAfter) openCart();
    //             });

    //             if($('.block-product-discount-checkbox').length){
    //                 if(arr.length != 0 && $('.quick-buy-drawer > *').length == 0){
    //                     addCartMultipleItems(arr)
    //                 }
    //             }

    //             checkIfDealer(data);
    //         },
    //         error: function(error) {
    //             openCart();

    //             // Try to update item and to show the error for limit
    //             setCartContent().then(() => {
    //                 shopifyCart.items.map((item) => {
    //                     if(item.id === id && item.quantity < quantity) {
    //                         $('#cart-item-quantity-' + id).parent().after('<small class="error">Only '+item.quantity+' items available.</small>')
    //                     }
    //                 })
    //             })
    //         }
    //     });
    // }

    function addCartItemFromForm(
        $form,
        openCartAfter = true,
        angiService = null,
        arr = []
    ) {
        const serializedArray = $form.serializeArray();

        let mainVariantId = null;
        let mainQuantity = 1;
        let mainProductTitle = '';

        const properties = {};

        serializedArray.forEach((field) => {
            if (field.name === 'id') {
                mainVariantId = parseInt(field.value, 10);
            } else if (field.name === 'quantity') {
                mainQuantity = parseInt(field.value, 10) || 1;
            } else if (field.name === 'product_title') {
                mainProductTitle = field.value;
            } else if (field.name.startsWith('properties[')) {
                const match = field.name.match(/^properties\[(.*)\]$/);
                if (match) {
                    properties[match[1]] = field.value;
                }
            }
        });

        // Fallback: try to get product title from form attribute or input if not present
        if (!mainProductTitle) {
            mainProductTitle =
                $form.find('[name="product_title"]').val() ||
                $form.data('product-title') ||
                '';
        }

        const items = [
            {
                id: mainVariantId,
                quantity: mainQuantity,
                ...(Object.keys(properties).length ? { properties } : {})
            }
        ];

        // Add Angi upsell service item if provided
        if (angiService && angiService.variantId) {
            items.push({
                id: parseInt(angiService.variantId, 10),
                quantity: parseInt(angiService.quantity, 10) || 1,
                properties: {
                    _angi_assembly: "true",
                    _angi_associated_variant_id: String(mainVariantId),
                    _For_Product: angiService.productTitle || mainProductTitle || ""
                },
                parent_id: mainVariantId
            });
        }

        function sendRequest(includeParentId = true) {
            const requestItems = items.map((item) => {
                const clonedItem = {
                    ...item,
                    properties: item.properties ? { ...item.properties } : undefined
                };

                if (!includeParentId) {
                    delete clonedItem.parent_id;
                }

                return clonedItem;
            });

            return $.ajax({
                type: 'POST',
                url: `${Shopify.routes.root}cart/add.js`,
                dataType: 'json',
                contentType: 'application/json',
                processData: false,
                data: JSON.stringify({
                    items: requestItems
                }),
                success: function(data) {
                    setCartContent().then(() => {
                        if (openCartAfter) {
                            openCart();
                        }
                    });

                    if ($('.block-product-discount-checkbox').length) {
                        if (arr.length !== 0 && $('.quick-buy-drawer > *').length === 0) {
                            addCartMultipleItems(arr);
                        }
                    }

                    checkIfDealer(data);
                },
                error: function(error) {
                    // Retry without parent_id if Shopify returns 422
                    // This can happen when Script Editor is installed
                    if (
                        error.status === 422 &&
                        includeParentId &&
                        angiService &&
                        angiService.variantId
                    ) {
                        console.warn('parent_id caused 422, retrying without parent_id');
                        return sendRequest(false);
                    }

                    openCart();

                    // Try to update item and show stock limit error
                    setCartContent().then(() => {
                        shopifyCart.items.map((item) => {
                            if (
                                item.id === mainVariantId &&
                                item.quantity < mainQuantity
                            ) {
                                $('#cart-item-quantity-' + mainVariantId)
                                    .parent()
                                    .after(
                                        '<small class="error">Only ' +
                                        item.quantity +
                                        ' items available.</small>'
                                    );
                            }
                        });
                    });
                }
            });
        }

        return sendRequest(true);
    }

    function addCartMultipleItems(items, openCartAfter = true) {
        return $.ajax({
            type: 'POST',
            url: `${Shopify.routes.root}cart/add.js`,
            dataType: 'json',
            data: {items},
            success: function(data) {
                setCartContent().then((openCartAfter) ? openCart : null)
            },
            error: function (error) {
                openCart()

                // Try to update item and to show the error for limit
                setCartContent().then(() => {
                    shopifyCart.items.map((item) => {
                        if(item.id === id && item.quantity < quantity) {
                            $('#cart-item-quantity-' + id).parent().after('<small class="error">Only '+item.quantity+' items available.</small>')
                        }
                    })
                })
            }
        });
    }

    function closeCart() {
        $('body').removeClass('no-scroll')
        $(nodeSelectors.cartContent).addClass('hidden')
        $(nodeSelectors.cart).fadeOut(200)
        // setTimeout(() => $(nodeSelectors.cart).fadeOut(200), 200)
    }

    function openCart() {
        $('.mobile-menu').removeClass('active');
        $('.menu-opener').removeClass('open');
        $('.menu-opener').removeClass('open');
        $('.header-overaly').fadeOut(50);
        $('body').removeClass('no-menu-scroll');
        $(nodeSelectors.cart).fadeIn();
        $(nodeSelectors.cartContent).removeClass('hidden')
        $('body').addClass('no-scroll')

        $('.quick-view-wrap').fadeOut('fast').removeClass().empty().remove();
        // $(nodeSelectors.cart).fadeIn(400, () => {
        //     $(nodeSelectors.cartContent).removeClass('hidden')
        //     $('body').addClass('no-scroll')
        // });


        if($('.additional-checkout-buttons ul li').length > 0){
            $(nodeSelectors.cartSecureCheckoutOpener).css('display', 'block')
            $('.regular-checkout-button').css('display', 'none')
        } else{
            $(nodeSelectors.cartSecureCheckoutOpener).css('display', 'none')
            $('.regular-checkout-button').css('display', 'block')
        }
    }

    function closeNotice() {
        $('body').removeClass('no-scroll')
        $(nodeSelectors.noticeContent).addClass('hidden')
        $(nodeSelectors.notice).fadeOut(200)
    }

    function openNotice() {
        $(nodeSelectors.notice).fadeIn();
        $(nodeSelectors.noticeContent).removeClass('hidden')
        $('body').addClass('no-scroll')
    }

    async function setTotalPrice() {
        if (!Shopify.designMode) {
            let totalRes = await fetch(`${Shopify.routes.root}?sections=cart-total`)
            let totalJson = await totalRes.json()
            
            //set timout to prevent unncesarry message of BROKEN HTML IN Shopiy customize
            setTimeout(function(){
                $(nodeSelectors.cartPrice).html(totalJson['cart-total']);
                if($('.total-savings').length < 1){
                    $('.savings-title').css('display', 'none')
                } else{
                    $('.savings-title').css('display', 'block')
                }
            }, 200)
        }
    }

    return Object.freeze({
        init,
        setCartContent,
        updateCartItem,
        addCartItem,
        openCart,
        closeCart
    })
}